import React, { useState, useEffect } from 'react'
import axios from 'axios'

const converterData = (data) => {
    const [ano, mes, dia] = data.split("-")

    const dataFormatada = `${dia}/${mes}/${ano}`

    return dataFormatada
}

const Home = () => {
    const [dados, setDados] = useState([])

    useEffect(() => {
        axios('/api/juridico/getProcessosUser')
            .then(res => setDados(res.data))
            .catch(error => alert(error.response.data.message))
    }, [])

    const excluirProcesso = (idProcesso) => {
        console.log(idProcesso)
        axios.post('/api/juridico/excluirProcesso', {id: idProcesso})
            .then(res => {
                alert(res.data.message)
                window.location = "/juridico/buscaProcesso"
            })
            .catch(error => console.log(error.response.data.message))
    }

    return (
        <>
            <div className="labelBuscaPed">
                <i className="bi bi-clipboard iconeBuscaPed"></i>
                MEUS PROCESSOS
            </div>
            <div className="overFlow">
                <div className="buscaPedHeader">
                    <div className="buscaPedElemntHeader">Número</div>
                    <div className="buscaPedElemntHeader">Tipo</div>
                    <div className="buscaPedElemntHeader">Data de Criação</div>
                    {localStorage.matriculaJ === "bruno.barros" ||
                        localStorage.matriculaJ === "carlos.francisco" ||
                        localStorage.matriculaJ === "nelson.modesto" ? (
                        <div className="buscaPedElemntHeader"></div>
                    ) : (<></>)}
                </div>
                {dados.map((el, index) => {
                    return (
                        <div className="buscaPedBody" key={`processo-${index}`}>
                            <a href={`/juridico/processo/${el._id}`}>
                                <div className="buscaPedElemntBody">{el.numero}/{el.dataCriacao.slice(0, 4)}</div>
                                <div className="buscaPedElemntBody">{el.tipo}</div>
                                <div className="buscaPedElemntBody">{converterData(el.dataCriacao.slice(0, 10))}</div>
                                {localStorage.matriculaJ === "bruno.barros" ||
                                    localStorage.matriculaJ === "carlos.francisco" ||
                                    localStorage.matriculaJ === "nelson.modesto" ? (
                                    <div className="buscaPedElemntBody"><button className="botaoNPed" onClick={() => excluirProcesso(el._id)}
                                        style={{ width: "20vw", backgroundColor: "red" }}>Excluir</button></div>
                                ) : (<></>)}
                            </a>
                        </div>
                    )
                })}
            </div>
        </>
    )
}

export default Home